import '@sections/toggle/components/_script';
import Swiper from 'swiper';
import { swiperOptions } from '@sections/images_carousel/section';
import { animatePlanCards } from '@sections/toggle/animate-plan-cards';
import { swiperOverviewCards } from '@sections/price_plan_overview_cards/section';
import { toggleItems } from '@src/components/toggleItems';
import { swiperOfferCards } from '../price_plan_offer_cards/section';

// Custom Segment tracking implementation for pricing toggle (not trackable links).
// We bind a click event on every toggle link and declare a custom analytics.track().
const segmentTrackingPricingToggle = () => {
  if (window.analytics && window.location.pathname.indexOf('/pricing') >= 0) {
    try {
      const links = document.querySelectorAll('#pricing-toggle a');
      links.forEach((link) => {
        link.addEventListener('click', (e) => {
          window.analytics.track('website_cta_pricing_toggle', {
            command: 'cta',
            category: 'Navigation',
            action: 'CTA',
            label: 'Pricing',
            location: 'pricing-toggle',
            target: 'https://qonto.com/fr/pricing?select-toggle=solo#' + link.dataset.paramsSlug
          });
        });
      });
    } catch (error) {
      console.log('Toggle Segment Error.');
    }
  }
};

const addSpacingToFirstAltPageElement = () => {
  const altPages = document.querySelectorAll('.alt-page');
  if (altPages) {
    altPages.forEach(page => {
      page.firstElementChild.classList.add('pt-32');
    });
  }
};

window.addEventListener('DOMContentLoaded', (_event) => {
  addSpacingToFirstAltPageElement();
  segmentTrackingPricingToggle();
  animatePlanCards();
});

const resetAnimation = () => {
  // reset carousel
  new Swiper('.swiper-container-carousel', swiperOptions);
  // reset swiper on overview cards
  swiperOverviewCards();
  // reset swiper on offer cards
  swiperOfferCards();
  // reset basic faq animation
  const $faqItems = $('.alt-page:not(.hidden) .faq-section .basic-faq .toggle-item');
  $faqItems.each(function () {
    const $title = $(this).find('.toggle-title');
    $title.off();
  });
  toggleItems($faqItems, true, true, true, true);
  // reset toggle items animation on mobile
  const $items = $('.alt-page:not(.hidden) .items-section .toggle-item');
  $items.each(function () {
    const $title = $(this).find('.toggle-title');
    $title.off();
  });
  toggleItems($items);
};

const selectAltPage = function (targetId) {
  // destroy swiper offer cards before adding a new one
  document.querySelectorAll('.swiper-offer-cards').forEach(element => {
    if (element.swiper) {
      element.swiper.destroy();
    }
  });
  // show the selected alt-page and reset animation after 300ms
  setTimeout(() => {
    $('.alt-page').each(function () {
      $(this).addClass('hidden');
    });
    $('#' + targetId).removeClass('hidden');
    resetAnimation();
  }, 300);
};

const selectAltTab = function (targetId) {
  $('.alt-page-tab').each(function () {
    $(this).removeClass('active');
  });
  $('[data-target-id=' + targetId + ']').addClass('active').trigger('classChange');
};

const selectSubtext = function (targetId) {
  const subtextSelector = '.toggle-section .subtext';
  $(subtextSelector).addClass('hidden');
  $(subtextSelector + '[data-item-id=' + targetId + ']').removeClass('hidden');
};

const toggleAltTabById = function (id) {
  selectAltPage(id);
  selectSubtext(id);
  selectAltTab(id);
  // .trigger('classChange');
};

const toggleAltTab = function (event) {
  event.preventDefault();

  const id = $(this).data('target-id');
  toggleAltTabById(id);
  try {
    history.replaceState(null, '', `${window.location.origin + window.location.pathname}?select-toggle=${$(this).data('params-slug')}`);
    // Show italian e-invoicing banner if on solo pricing page.
    const banner = document.getElementById('prismic-top-bar');
    if (!banner) return;
    if (window.location.pathname == '/it/pricing' && $(this).data('params-slug') == 'solo') {
      banner.classList.remove('hidden');
    } else if (window.location.pathname == '/it/pricing' && $(this).data('params-slug') != 'solo') {
      banner.classList.add('hidden');
    }
  } catch (e) {
    console.log(e);
  }
  // animateSections();
};

const resetBgClasses = (child, yellowBgClass, greyBgClass) => {
  if (child.className.indexOf(greyBgClass) >= 0) {
    child.classList.remove(greyBgClass);
  } else if (child.className.indexOf(yellowBgClass) >= 0) {
    child.classList.remove(yellowBgClass);
  };
};

// Add highlighted bg color on the first colomn of pricing table on mobile (app/sections/compare_plans_v3/section.js)
const colorizeBackgroundColor = async (parentElSelector, childrenElSelectors) => {
  const parentsElements = document.querySelectorAll(parentElSelector);
  const yellowBgClass = 'bg-mustard-50';
  const greyBgClass = 'bg-grey-50';
  parentsElements.forEach((parentsEl) => {
    Array.from(parentsEl.querySelectorAll(childrenElSelectors)).map((child, index) => {
      resetBgClasses(child, yellowBgClass, greyBgClass);
      const bgColor = index === 0 ? greyBgClass : yellowBgClass;
      child.classList.add(bgColor);
    });
  });
};

const colorizeHeadersBgColor = () => {
  colorizeBackgroundColor('.comparable', '.plan-header-mobile-js');
};

const colorizeFeaturesBgColor = () => {
  colorizeBackgroundColor('.feature', '.feature-box-js');
};

document.addEventListener('DOMContentLoaded', function (event) {
  initSelectOptions();
  $('.alt-page-tab').click(toggleAltTab);

  $('#pricing-toggle a').on('click', function (e) {
    clearSelectOptions();
  });

  $('.comparable select').on('change', function (e) {
    const line_up_page = $(this).closest('.compare-plans-v3-section-mobile-js');
    const plan_id_to_hide = $(this).closest('.compared').data('plan');
    const plan_id_to_show = $(this).val();
    const features_to_show = $('.feature_' + plan_id_to_show);
    const features_to_hide = $('.feature_' + plan_id_to_hide);
    // Move the hidden soon to show before the one to_hide
    $(line_up_page).find('.compared_' + plan_id_to_show).each(function () {
      $(this).insertBefore($(this).parent().find('.compared_' + plan_id_to_hide));
      $(this).removeClass('hidden');
    });

    $(line_up_page).find('.compared_' + plan_id_to_hide).each(function () {
      $(this).closest('.comparable').append($(this));
      $(this).addClass('hidden');
    });

    // Reorder + hide/show features
    $(line_up_page).find(features_to_show).each(function () {
      $(this).insertBefore($(this).parent().find('.feature_' + plan_id_to_hide));
      $(this).removeClass('hidden');
    });
    $(line_up_page).find(features_to_hide).each(function () {
      $(this).parent().append($(this));
      $(this).addClass('hidden');
    });

    colorizeHeadersBgColor();
    colorizeFeaturesBgColor();
    // Need to clean & update the select menu to avoid 2 times the same choice (aka premium in each select)
    clearSelectOptions(line_up_page);
  });

  $('section.toggle-section').on('init-section', function (event, params) {
    event.stopPropagation();
    const urlParams = new URLSearchParams(window.location.search);
    const slug = urlParams.get('select-toggle');
    if (slug) {
      const elem = $(this).find('.alt-page-tab[data-params-slug=' + slug + ']');
      if (elem.length) {
        toggleAltTabById(elem.data('target-id'));
      }
    }

    // we propagate the init to the active page
    // This part is a bit fragile, ... it means if the page does not have a toggle
    // not JS init will be passed down
    $('.alt-page:not(.hidden)').trigger('init-page', params);
  });
});

// Remove unwanted option from selects and define the right selected value
const clearSelectOptions = function (line_up_page) {
  $(line_up_page).find('select').each(function () {
    $(this).empty().append($('.comparable:visible:first').data('options'));
  });
  setTimeout(function () {
    $(line_up_page).find('.comparable').each(function () {
      const compared = $(this).find('.compared:visible');
      if (compared.lengh == 0) { return; }
      const $first_compared = compared.first();
      const $second_compared = compared.last();
      $first_compared.find('select option[value=' + $second_compared.data('plan') + ']').remove();
      $second_compared.find('select option[value=' + $first_compared.data('plan') + ']').remove();

      // Repositioning the value as the remove above destroy the selection
      $(line_up_page).find('.compared').each(function () {
        $(this).find('select').val($(this).data('plan'));
      });
    });
  }, 30);
};

// Timeout required here to ensure clearSelectOptions() is done
const initSelectOptions = function () {
  setTimeout(function () {
    $('.comparable:visible').each(function () {
      $(this).find('select:visible:last option[value=\'' + $('.comparable select:visible:first').val() + '\']').remove();
    });
  }, 10);
  setTimeout(function () {
    $('.comparable:visible').each(function () {
      $(this).find('select:visible:first option[value=\'' + $('.comparable select:visible:last').val() + '\']').remove();
    });
  }, 10);
  $('.compared:visible').each(function () {
    $(this).find('select').val($(this).data('plan'));
  });
};

$(window).resize(initSelectOptions);
$('.alt-page-tab').on('click', initSelectOptions);

export {
  initSelectOptions,
  clearSelectOptions,
  colorizeHeadersBgColor,
  colorizeFeaturesBgColor
};
